import { Dashboard } from 'components/Layout';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import api from 'api/api';
import { compose } from 'ramda';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { OrganizationType } from 'store/modules/organizations/organizations';
import Groups from 'components/OrganizationAdmin/Users/UserShared/Groups';
import Menu, { Tab } from './Menu';
import Projects from 'components/OrganizationAdmin/Users/UserShared/Projects';
import { BackTo } from '@deeptrue-frontend/ui';
import ROUTES from 'consts/routing';
import { OrganizationUser } from 'pages/OrganizationAdmin/types';
import Products from 'components/OrganizationAdmin/Users/UserShared/Products';
import queryString from 'query-string';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, selectors } = StoreProvider;

interface Props extends RouteComponentProps {
  organization: OrganizationType;
  match: {
    isExact: boolean;
    path: string;
    url: string;
    params: {
      id: string;
    };
  };
}

const UserSharedPage = ({ location, organization, match, history }: Props) => {
  const t = useFormatMessage();
  const [tab, selectTab] = useState<Tab>(
    (queryString.parse(location.search) as { tab: Tab }).tab
  );

  const [userData, setUserData] = useState<OrganizationUser>({
    id: 0,
    is_active: false,
    organization_role: 0,
    user: {
      id: undefined,
      name: '',
      org_groups: [],
      shared_projects: [],
      shared_products: [],
    },
  });

  const [isLoaded, setIsLoaded] = useState(false);
  const { id } = match.params;

  const getUser = () => {
    return (
      api.resources.organization.users
        .getOrganizationUser({
          organizationCodename: organization.codename,
          userId: id,
        })
        // @ts-ignore
        .then(({ data }: { data }) => {
          setUserData({ ...data });
        })
        .finally(() => {
          setIsLoaded(true);
        })
    );
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Dashboard
      title={`Admin / User ${userData.user.name || ''}`}
      location={location}
    >
      <BackTo onClick={() => history.push(ROUTES.ORGANIZATION.ADMIN.USERS)}>
        <span>
          {`${t('organization.backTo', 'Back to')} ${t(
            'organization.users',
            'Users'
          )}`}
        </span>
      </BackTo>
      <Menu tab={tab} selectTab={selectTab} />
      {tab === 'groups' && (
        <Groups
          organizationCodename={organization.codename}
          userData={userData.user}
          isLoaded={isLoaded}
          userId={userData.id}
          refreshUser={getUser}
        />
      )}
      {tab === 'projects' && (
        <Projects
          userData={userData.user}
          isLoaded={isLoaded}
          organizationCodename={organization.codename}
          refreshUser={getUser}
          userId={userData.id}
        />
      )}
      {tab === 'products' && (
        <Products
          userData={userData.user}
          isLoaded={isLoaded}
          organizationCodename={organization.codename}
          refreshUser={getUser}
          userId={userData.id}
        />
      )}
    </Dashboard>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
    isAdmin: selectors.authSelectors.isOrganizationAdmin(state),
  }))
)(UserSharedPage);
